<template>
  <div class="projects">
    <h3 class="projects_title mb-12">Реализованные проекты</h3>
    <div class="projects_header mb-12">
      <button @click="changeSlide('korf')" :class="{'projects_header-title--active': slide === 'korf'}" class="projects_header-title">KORF</button>
      <button @click="changeSlide('ned')" :class="{'projects_header-title--active': slide === 'ned'}" class="projects_header-title">НЭД</button>
      <button @click="changeSlide('bimlib')" :class="{'projects_header-title--active': slide === 'bimlib'}" class="projects_header-title">BIMLIB</button>
      <button @click="showModal = true" class="projects_header-add">
        <svg viewBox="0 0 44 44">
          <use xlink:href="/dist/assets/front_white/img/software/add.svg#plus" overflow="visible" />
        </svg>
        <div class="projects_header-add-text">свой проект</div>
      </button>
    </div>
    <transition name="slide-fade">
      <div v-show="slide === 'korf'" class="projects-item">
        <div class="projects-item_column">
          <img src="/dist/assets/front_white/img/man0/feature-1.svg" class="projects-item_img">
          <h4 class="projects-item_title">Разработка плагина для KORF</h4>
          <p>Компания «Гидрозо» предлагает комплексный подход для гидроизоляции, а мы воплотили эту технологию в виде библиотеки элементов для Revit. <br><br> Гидроизоляция проводится в два этапа: до бетонирования закладывается профиль из гидрофильной резины и инъекционные шланги, а после всё покрывается цементным или полицементным составом.</p>
        </div>
        <div class="projects-item_column">
          <p>Стены и фундаментные плиты можно копировать между проектами, новые типы семейств появятся в проекте, а вместе с ними и все заложенные параметры. Пироги стен и плит уже настроены, ничего дополнительно делать не придётся. Давайте посмотрим на несколько примеров. <br><br> На иллюстрациях ниже пример фундаментной плиты и стены, покрытые гидроизоляционными материалами. В свойствах виден состав пирога и заполненные согласно BIM 2.0 параметры семейств. Кроме самих плит и стен, свойства содержатся в материалах, входящих в структуру элементов. <br><br> Элементы поверх стены — это линейные семейства гидроизолирующего покрытия, под ними находится ещё один элемент гидроизоляции — ремонтный состав на цементной основе. </p>
        </div>
        <div class="projects-item_column">
          <p>Для быстрого подсчёта материалов в файл проекта с BIM-моделями добавлены ведомости по форме 7 из ГОСТ Р 21.1101-2013. Одна из них считает расход материалов, например количество раствора для стяжки, а вторая — длину гидроизолирующих покрытий и профилей. Количество материалов считается на выбор пользователя в квадратных или кубических метрах и килограммах. Для этого есть специальный параметр ADSK_Материал тип подсчета, в зависимости от числового кода расход материала пересчитывается в нужных единицах.</p>
          <div class="projects-item_column-line mt-11"></div>
          <bimButton @click="showModal = true" class="mt-11" size="l" outline width="220" label="Заказать похожий проект"></bimButton>
        </div>
      </div>
    </transition>
    <transition name="slide-fade">
      <div v-show="slide === 'ned'" class="projects-item">
        <div class="projects-item_column">
          <img src="/dist/assets/front_white/img/man0/feature-1.svg" class="projects-item_img">
          <h4 class="projects-item_title">Разработка плагина для KORF</h4>
          <p>Компания «Гидрозо» предлагает комплексный подход для гидроизоляции, а мы воплотили эту технологию в виде библиотеки элементов для Revit. <br><br> Гидроизоляция проводится в два этапа: до бетонирования закладывается профиль из гидрофильной резины и инъекционные шланги, а после всё покрывается цементным или полицементным составом.</p>
        </div>
        <div class="projects-item_column">
          <p>Стены и фундаментные плиты можно копировать между проектами, новые типы семейств появятся в проекте, а вместе с ними и все заложенные параметры. Пироги стен и плит уже настроены, ничего дополнительно делать не придётся. Давайте посмотрим на несколько примеров. <br><br> На иллюстрациях ниже пример фундаментной плиты и стены, покрытые гидроизоляционными материалами. В свойствах виден состав пирога и заполненные согласно BIM 2.0 параметры семейств. Кроме самих плит и стен, свойства содержатся в материалах, входящих в структуру элементов. <br><br> Элементы поверх стены — это линейные семейства гидроизолирующего покрытия, под ними находится ещё один элемент гидроизоляции — ремонтный состав на цементной основе. </p>
        </div>
        <div class="projects-item_column">
          <p>Для быстрого подсчёта материалов в файл проекта с BIM-моделями добавлены ведомости по форме 7 из ГОСТ Р 21.1101-2013. Одна из них считает расход материалов, например количество раствора для стяжки, а вторая — длину гидроизолирующих покрытий и профилей. Количество материалов считается на выбор пользователя в квадратных или кубических метрах и килограммах. Для этого есть специальный параметр ADSK_Материал тип подсчета, в зависимости от числового кода расход материала пересчитывается в нужных единицах.</p>
          <div class="projects-item_column-line mt-11"></div>
          <bimButton @click="showModal = true" class="mt-11" size="l" outline width="220" label="Заказать похожий проект"></bimButton>
        </div>
      </div>
    </transition>
    <transition name="slide-fade">
      <div v-show="slide === 'bimlib'" class="projects-item">
        <div class="projects-item_column">
          <img src="/dist/assets/front_white/img/man0/feature-1.svg" class="projects-item_img">
          <h4 class="projects-item_title">Разработка плагина для KORF</h4>
          <p>Компания «Гидрозо» предлагает комплексный подход для гидроизоляции, а мы воплотили эту технологию в виде библиотеки элементов для Revit. <br><br> Гидроизоляция проводится в два этапа: до бетонирования закладывается профиль из гидрофильной резины и инъекционные шланги, а после всё покрывается цементным или полицементным составом.</p>
        </div>
        <div class="projects-item_column">
          <p>Стены и фундаментные плиты можно копировать между проектами, новые типы семейств появятся в проекте, а вместе с ними и все заложенные параметры. Пироги стен и плит уже настроены, ничего дополнительно делать не придётся. Давайте посмотрим на несколько примеров. <br><br> На иллюстрациях ниже пример фундаментной плиты и стены, покрытые гидроизоляционными материалами. В свойствах виден состав пирога и заполненные согласно BIM 2.0 параметры семейств. Кроме самих плит и стен, свойства содержатся в материалах, входящих в структуру элементов. <br><br> Элементы поверх стены — это линейные семейства гидроизолирующего покрытия, под ними находится ещё один элемент гидроизоляции — ремонтный состав на цементной основе. </p>
        </div>
        <div class="projects-item_column">
          <p>Для быстрого подсчёта материалов в файл проекта с BIM-моделями добавлены ведомости по форме 7 из ГОСТ Р 21.1101-2013. Одна из них считает расход материалов, например количество раствора для стяжки, а вторая — длину гидроизолирующих покрытий и профилей. Количество материалов считается на выбор пользователя в квадратных или кубических метрах и килограммах. Для этого есть специальный параметр ADSK_Материал тип подсчета, в зависимости от числового кода расход материала пересчитывается в нужных единицах.</p>
          <div class="projects-item_column-line mt-11"></div>
          <bimButton @click="showModal = true" class="mt-11" size="l" outline width="220" label="Заказать похожий проект"></bimButton>
        </div>
      </div>
    </transition>
    <bimPhoneRequest
      v-model="showModal"
      :userContext="user_info"
      :logActionEvent="$logActionEvent"
      apiPrefix="/web-api-2"
      :formType="2"
    />

  </div>
</template>

<script>
import bimButton from '@bimlib/components/bimButton'
import bimPopup from '@bimlib/components/bimPopup'
import bimPhoneRequest from '@bimlib/components/bimPhoneRequest'

export default {
  components: {
    bimButton,
    bimPhoneRequest,
    bimPopup
  },
  props: {
    user_info: Object,
  },
  data () {
    return {
      slide: 'korf',
      showModal: false
    }
  },
  methods: {
    changeSlide(val) {
      if (this.slide != val) {
        this.slide = '';
			  setTimeout(() => this.slide = val, 220);
      }
		}
  },
  computed: {

  }
}

</script>

<style lang="scss" scoped>
@import './src/front_white/sass/components/color';
@import './src/front_white/sass/components/settings';

.slide-fade-enter-active {
  transition: all .5s ease .5s;
}
.slide-fade-leave-active {
  // transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active до версии 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.projects {
  @media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {
    padding: 8px;
  }
}

.projects_title {
  font-size: 32px;
  font-weight: bold;

  @media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {
    text-align: center;
  }
}

.projects_header {
  display: flex;

  &-title {
    font-size: 86px;
    font-weight: bold;
    color: #d7d7d7;
    margin-right: 42px;

    @media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {
      font-size: 14px;
      margin-right: 12px;
    }

    &:hover {
      color: $active;
    }
  }

  &-title--active {
    color: $active;
  }

  &-add {
    display: flex;
    align-items: center;
    color: #d7d7d7;
    transition: 0s;

    svg {
      width: 44px;
      height: 44px;
      margin-right: 12px;
      transition: all 0s;

      @media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {
        width: 14px;
        height: 14px;
        margin-right: 8px;
      }
    }

    svg use {
      width: 14px;
      height: 14px;
    }

    &:hover {
      color: $active;
    }
  }

  &-add-text {
    font-size: 32px;
    font-weight: bold;
    max-width: 140px;
    text-transform: uppercase;
    transition: all 0s;

    @media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {
      font-size: 14px;
    }
  }
}

.projects-item {
  display: grid;
  grid-template-columns: 4fr 3fr 3fr;
  grid-gap: 32px;

  @media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {
    grid-template-columns: 1fr;
  }

  &_img {
    margin-bottom: 32px;
  }

  &_title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 14px;
  }

  &_column-line {
    width: 75px;
    height: 1px;
    border: solid 1.5px #dbdbdb;
  }
}


</style>
